import { useEffect, useState, useRef } from "react";
import { useUrlParamParser } from "../../page/util/url-param-parse.hook"

const DiscountDetail = ({ applicableDiscount }: { applicableDiscount: number }) => {
    const { checkoutId } = useUrlParamParser();
    const TIMER_KEY = `${checkoutId}_discount_timer`;

    const getInitialTime = () => {
        const stored = localStorage.getItem(TIMER_KEY);
        if (stored) {
            const parsed = parseInt(stored, 10);
            if (!isNaN(parsed) && parsed > 0 && parsed <= 15 * 60) {
                return parsed;
            }
        }
        return 15 * 60;
    };

    const [secondsLeft, setSecondsLeft] = useState(getInitialTime());
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    localStorage.setItem(TIMER_KEY, (15 * 60).toString());
                    return 15 * 60;
                }
                localStorage.setItem(TIMER_KEY, (prev - 1).toString());
                return prev - 1;
            });
        }, 1000);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, []);

    const minutes = Math.floor(secondsLeft / 60)
        .toString()
        .padStart(2, '0');
    const seconds = (secondsLeft % 60).toString().padStart(2, '0');
    return (
        <div className="bg-[#F1F9E0] border border-solid border-[#AFE137] rounded-[8px] px-[12px] py-[4px] justify-around flex items-center gap-[4px]">
            <div className="flex items-center justify-start gap-[4px]">
                <p className="text-[26px]">🎉</p>

                <p className="font-robotoRegular text-[14px] text-[#3D494B]">
                    Get <span className="font-robotoBold">₹{applicableDiscount}</span> off on this order
                </p>
            </div>
            <div className="flex gap-[2px] items-center">
                <img src="/assets/images/clock.svg" className="w-[14px] h-[14px]" />
                <span className="text-[#D31919] font-interMedium text-[11px]">
                    Ends in {minutes}:{seconds}
                </span>
            </div>
        </div>
    );
};

export default DiscountDetail;
